import React from "react";

import { connect } from "react-redux";
import { history } from "../_helpers";
import { userService } from "../_services/user.service";
import { showGlobalSnackbar } from "../_services/snackbarService";
import { dropCache } from "../CardApp/offlineCache";
import { flushCardConsents } from "../CardApp/consents";
import {
  NATIVE_OAUTH_KEY,
  NATIVE_OAUTH_SCHEME,
  NATIVE_OAUTH_TTL,
} from "../CardApp/nativeBridge";
import { defaultLang, landingDomain, cardMode } from "../_constants";
import { cn as lang_cn } from "../_lang/cn.json";
import { en as lang_en } from "../_lang/en.json";
import { ru as lang_ru } from "../_lang/ru.json";

function setStorage(name, val) {
  localStorage.setItem(name, val);
}

const exchangedCodes = new Set();

class OAuthPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      pwd: "",
      submitted: false,
      getCb: false,
      isNew: false,
      agreeOk: false,
      slotInfoOpen: false,
    };
  }

  getI18N = (textKey) => {
    const { lang } = this.state;
    if (!lang) return;
  
    if (lang == "ru") {
      if (Object.keys(lang_ru.translation).indexOf(textKey) >= 0) return lang_ru.translation[textKey];
    }
    if (lang == "en") {
      if (Object.keys(lang_en.translation).indexOf(textKey) >= 0) return lang_en.translation[textKey];
    }
    if (lang == "cn") {
      if (Object.keys(lang_cn.translation).indexOf(textKey) >= 0) return lang_cn.translation[textKey];
    }
      return textKey;
    };

  // Возврат в мобильное приложение «визитка». Вход открывался снаружи (приложение
  // провайдера или браузер), и сейчас мы в браузере — обменивать code здесь нельзя:
  // токен остался бы в браузере, а в приложении человек был бы не авторизован.
  // Вместо обмена уходим на схему приложения, обёртка грузит эту же страницу
  // у себя (localhost:8080), и code меняет на токен уже она.
  //
  // Файл общий с веб-кабинетом, эта ветка уезжает и на lk.naviconf.com. Отсюда три
  // страховки: маркер одноразовый (снимается до всех проверок), протухает и работает
  // только вместе с непустым code. Залипший маркер увёл бы обычный веб-вход на
  // naviconfcard:// — на проде это заметят раньше, чем мы.
  returnToNativeApp = () => {
    const raw = localStorage.getItem(NATIVE_OAUTH_KEY);
    localStorage.removeItem(NATIVE_OAUTH_KEY);

    const fresh = raw && Date.now() - Number(raw) < NATIVE_OAUTH_TTL;
    const code = new URLSearchParams(window.location.search).get("code");

    if (!fresh || !code || window.location.hostname === "localhost") return false;

    // Путь колбэка уже соответствует роуту (/vkontakte-callback, /leaderid-callback,
    // /yandex-callback), сопоставление по oauthService не нужно. Query переносится
    // целиком, чтобы не потерять state и прочие параметры провайдера.
    window.location.replace(
      NATIVE_OAUTH_SCHEME + window.location.pathname + window.location.search
    );
    return true;
  };

  componentDidMount() {
    if (this.returnToNativeApp()) return;

    const self = this;

    let lang = localStorage.getItem("navic_lang") ?? defaultLang;
    this.setState({ lang });

    let str = window.location.href;

    let userType = localStorage.getItem("nc_usertype");

    console.log(str);

    let str_arr = str.split("code=");
    if (str_arr.length > 1) {
      str = str_arr[1];
      str_arr = str.split("&state");
      str = str_arr[0];

      if (exchangedCodes.has(str)) return;
      exchangedCodes.add(str);

      const cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete("code");
      const cleanQs = cleanParams.toString();
      window.history.replaceState(
        {},
        "",
        window.location.pathname + (cleanQs ? `?${cleanQs}` : "")
      );

      localStorage.setItem("user", "{}");
      dropCache();

      // В приложении «визитка» аккаунт всегда «посетитель», а вход и регистрация — одно
      // действие: create_type заводит нового пользователя, а существующего логинит с его
      // типом, поэтому организатор со своей почтой не упирается в 403. Тип из nc_usertype
      // здесь не нужен вовсе.
      let urlStr = `api/token/${this.props.oauthService}?code=${str}`;

      if (cardMode) urlStr += "&create_type=student";
      else if (userType) urlStr += `&type=${userType}`;

      userService.getWrapper(
        urlStr,
        (data) => {
          if (data && data.data && data.data.token) {
            const payload = data.data;

            // Та же логика, что в _actions/user.js login(): в card-режиме согласия
            // уже собраны гейтом CardApp/AgreementGate.js при запуске, /agreement не
            // нужна — фиксация на бэке уходит в фоне.
            if (cardMode) {
              flushCardConsents(payload.token, payload.is_agreement_accepted);
              payload.is_agreement_accepted = true;
            }

            if (payload.is_agreement_accepted === false) {
              setStorage("token_tmp", payload.token);
              setStorage("token", "");
              history.push("/agreement");
            } else {
              setStorage("token", payload.token);
              let nc_red = localStorage.getItem("navic_redirect");
              localStorage.setItem("navic_redirect", "");

              if (nc_red) {
                localStorage.setItem("tickets_open", "1");
                history.push(nc_red);
              } else history.push("/");
            }
          }
        },
        (error) => {
          let errorCode = 0;

          if (error) {
            if (error.response && error.response.status) {
              errorCode = error.response.status;
            } else if (error.status) {
              errorCode = error.status;
            } else if (error.toString().includes("404")) {
              errorCode = 404;
            }

            if (errorCode == 404) {
              showGlobalSnackbar(this.getI18N("user_not_found_registry"), "error");
              history.push("/registration");
            } else if (errorCode == 403) {
              showGlobalSnackbar(this.getI18N("user_already_exists"), "error");
            } else showGlobalSnackbar(this.getI18N("registration_error"), "error");
          } else showGlobalSnackbar(this.getI18N("registration_error"), "error");
        }
      );
    }
  }

  clickAgr = () => {
    window.open(`https://${landingDomain}/privacy-policy`);
  };

  render() {
    return <div>Loading...</div>;
  }
}

function mapStateToProps(state) {
  const { loggingIn, error } = state.authentication;
  return {
    loggingIn,
    error,
  };
}

const connectedOAuthPage = connect(mapStateToProps)(OAuthPage);
export { connectedOAuthPage as OAuthPage };
